<template>
    <div>
        <div class="dataTables_wrapper dt-bootstrap4">
            <div class="row">
                <div class="col-lg-6 pl-5 pr-5 pb-5 position-relative">
                    <h5><small class="mb-0">{{$t('outlet_setting.security_config.header_auth')}}</small></h5>
                    <b-table v-if="authorization.length != 0" small striped hover bordered :fields="fields" :items="authorization" responsive>
                        <template #cell(index)="data">
                            {{ data.index + 1 }}
                        </template>
                        <template #cell(action)="data">
                            <a class="link text-primary" @click="deleteContact(data.item)">
                                <i class="fal fa-trash"></i>
                            </a>
                        </template>
                    </b-table>
                    <div class="panel-tag mt-3" v-else>{{$t('table.no_records')}}
                    </div>
                </div>
                <div class="col-lg-6 p-5 border-left">
                    <div class="card border">
                        <div class="card-body">
                            <div class="border-bottom mb-5"><p class="card-title">{{$t('button_link.add')}}{{$t('outlet_setting.security_config.authorization')}}</p></div>
                            <form @submit.prevent="editSecuritySettings">
                                <div class="form-group">
                                    <label class="form-label">{{$t('label.contact')}}</label>
                                    <div class="input-group bg-white shadow-inset-2">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text bg-transparent border-right-0">
                                                <i class="fas fa-phone-alt"></i>
                                            </span>
                                        </div>
                                        <input id="contact" type="text" class="form-control bg-transparent pl-3" :placeholder="$t('label.contact')" v-model="contact"  @keyup="contactValidation" required="">
                                    </div>
                                    <div id="err" class="error-validation"></div>
                                </div>
                                <div class="text-left mb-3">
                                    <button type="submit" class="btn border-0 btn-primary btn-padding waves-effect waves-themed">{{$t('button_link.save')}}</button>
                                </div>
                                <div class="border-top mt-5 pt-3 help-block fs-xs">
                                    <p>{{$t('message.contact_validation.notes')}}:</p>
                                    <ul>
                                        <li>{{$t('message.contact_validation.my')}} 601x xxx xxxx</li>
                                        <li>{{$t('message.contact_validation.sg')}} 65x xxx xxxx</li>
                                    </ul>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>                
        </div>
        <deleteModal ref="deleteModal" @performConfirmAction="performDeleteAction"></deleteModal>
    </div>
</template>
<script>
import DeleteModal from './../../Delete_Modal'
import {contactValidation} from '@/assets/js/dashboard/utilities.js'
export default {
    name: 'authorization',
    props:{
        authorization: { type: Array }
    },
    components: {
        DeleteModal
    },
    data(){
        return{
            contact: "", objContact: {},
            selectedContact: {}
        }
    },
    computed:{
        fields(){
            return[
                { key: "index", label: "#", thClass: 'thead-themed align-middle'},
                { key: "mobile", label: this.$i18n.t('table.header.contact'), thClass: 'thead-themed align-middle'},
                { key: "action", label: "", thClass: 'thead-themed text-center', tdClass: 'text-center'},
            ]
        }
    },
    methods:{
        contactValidation(){
            var err = contactValidation(this.contact);
            document.getElementById('err').innerHTML = err == null ? null : this.$i18n.t('message.contact_validation.phone_number', {
                'error':  this.$i18n.t(`message.contact_validation.error.${err}`)
            })
        },
        editSecuritySettings(){
            var authorization = this.authorization.slice()
            authorization.push({
                mobile: this.contact
            })

            this.$emit('submitEdit', {authorize: authorization});
            this.contact = "";
        },
        deleteContact(item){
            var title = this.$i18n.t('outlet_setting.security_config.header_delete')
            var message = this.$i18n.t('message.confirmation.question', {'action': this.$i18n.t('message.confirmation.action.remove'),'item': item.mobile})
            this.selectedContact = item
            this.$refs.deleteModal.showModal(title, message)
        },
        performDeleteAction(){
            var authorization = this.authorization.slice()
            authorization = authorization.filter(obj => obj.mobile != this.selectedContact.mobile)
            this.$emit('submitEdit', {authorize: authorization});
        }
    }
}
</script>

<style scoped>
.add-icon{
    opacity: 0.3;
    color: #886ab5;
}
.error-validation{
    font-size: 0.6875rem;
    margin-top: 0.325rem;
    color: #fd3995;
}
.border-top{
    border-top: 1px dashed #dee2e6 !important;
}
</style>